import * as React from 'react'
import { Nav } from 'reactstrap'
import Page from 'shared/types/Page'
import MenuItem from './MenuItem'

interface SubMenuProps {
  pages: Page[]
  currentPage: Page | null
  setCurrentPage?: Function
}

const SubMenu: React.FunctionComponent<SubMenuProps> = (props) => {
  return (
    <Nav className='sub-nav'>
      {props.pages.map((pageProps: any, key: number | string) => {
        return (
          <MenuItem
            key={pageProps.name + '-sub-' + key}
            label={pageProps.name}
            link={pageProps.path}
            icon={pageProps.icon}
            pages={props.pages}
            currentPage={props.currentPage}
            setCurrentPage={props.setCurrentPage}
          />
        )
      })}
    </Nav>
  )
}

export default SubMenu
